<template>
    <div class="send-sms">
        <div style="text-align: center;">
            <button-group :buttonGroup="1" :options="buttonGroupOptions" @buttonGroupChange="buttonGroupChange" />
        </div>
        <div v-if="sendSms.type === 1">
            <el-card shadow="hover" class="box-card">
                <div slot="header" class="clearfix">
                    <span>短信内容</span>
                    <label for style="float: right; padding: 3px 0">
                        <el-checkbox v-model="notRepeat_w" size="mini">3天内不重复发送</el-checkbox>
                    </label for>
                </div>

                <el-input size="mini" :autosize="{ minRows: 2, maxRows: 8 }" type="textarea" v-model="sendSms.content"
                    placeholder="在此输入短信内容" :maxlength="maxlength" show-word-limit></el-input>

                <el-checkbox style="margin-top: 0.2rem;" v-model="addCompany" size="mini"
                    @change="handleAddCompanyChange">短信展示对方公司名称</el-checkbox>
            </el-card>
        </div>
        <div v-else-if="sendSms.type === 2" style="margin-top: 0.2rem;">
            <el-card shadow="hover" class="box-card">
                <div slot="header" class="clearfix">
                    <span>选择模版</span>
                    <label for style="float: right; padding: 3px 0">
                        <el-checkbox v-model="notRepeat_c" size="mini">3天内不重复发送</el-checkbox>
                    </label for>
                </div>
                <ChooseTemplate @handleChooesd="handleChooesd" />
            </el-card>
        </div>
        <div style="display: flex;margin-top: 0.2rem">
            <div style="margin-left: auto;">
                <el-button type="primary" @click.native="sendSMSExec" size="mini">提交</el-button>
            </div>
        </div>
        <i class="el-icon-s-opportunity" style="color:#E6A23C;font-size: x-small;">
            短信内容中不能出现:【】。
            <p style="margin-top: 0.1rem">填写内容,发送到该分类下所有客户,多个手机号,每个手机号都发送!</p>
        </i>
    </div>
</template>

<script>
import ButtonGroup from '../../../commonReform/ButtonGroup'
import ChooseTemplate from './ChooseTemplate'
export default {
    name: 'SendSMS',
    components: { ButtonGroup, ChooseTemplate },
    props: {
        cate: {
            required: true
        },
        kw: {
            type: String
        },
        callTaskIds: {
            type: Object
        }
    },
    data() {
        return {
            buttonGroupOptions: [
                {
                    label: '自定义',
                    value: 1
                },
                {
                    label: '选择模版',
                    value: 2
                },
            ],
            sendSms: {
                type: 1,
                content: ''
            },
            template_id: '',
            notRepeat_w: true,
            notRepeat_c: true,
            notRepeat: null,
            addCompany: null,
        }
    },
    methods: {
        buttonGroupChange(val) {
            this.sendSms.type = val
            this.template_id = ''
        },
        sendSMSExec() {
            if (this.sendSms.type === 1) {
                this.notRepeat = this.notRepeat_w
                if (!this.sendSms.content) {
                    this.$message.warning('发送内容没有填写!')
                    return false
                }
            } else if (this.sendSms.type === 2) {
                this.notRepeat = this.notRepeat_c
                if (!this.template_id) {
                    this.$message.warning('请选择短信模版!')
                    return false
                }
            }
            this.$axios.get('/api/api3_call_task/send_sms', {
                params: {
                    cate: this.cate,
                    type: this.sendSms.type,
                    content: this.sendSms.content,
                    template_id: this.template_id,
                    notRepeat: this.notRepeat,
                    kw: this.kw,
                    ids: this.callTaskIds
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        handleChooesd(val) {
            this.template_id = val
        },
        handleAddCompanyChange(val) {
            if (val) {
                this.sendSms.content += '#company'
            } else {
                this.sendSms.content = this.deleteString(this.sendSms.content, '#company')
            }
        },
        deleteString(str, target) {
            var result = "";
            var i = 0;
            while (i < str.length) {
                var chunk = str.substr(i, target.length);
                if (chunk === target) {
                    i += target.length;
                } else {
                    result += str[i];
                    i++;
                }
            }
            return result;
        }
    },
    computed: {
        maxlength() {
            return this.addCompany ? 51 : 59
        }
    }
}
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both
}

.send-sms .box-card {
    margin-top: 0.2rem;
    width: 480px;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/SendSMS.vue